import { useState } from 'react';
import { processPayment as processPaymentApi } from '../services/payment';
import { PaymentDetails, Payment } from '../types/payment';

type PaymentResult = { success: boolean; payment?: Payment } | null;

function isErrorWithMessage(err: unknown): err is { message?: unknown } {
  return typeof err === 'object' && err !== null && 'message' in err;
}

function getErrorMessage(err: unknown): string {
  if (!err) return 'Unknown error';
  if (typeof err === 'string') return err;
  if (isErrorWithMessage(err) && typeof err.message === 'string') return err.message;
  return String(err);
}

export const usePayment = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [paymentResult, setPaymentResult] = useState<PaymentResult>(null);

  const handlePayment = async (
    paymentData: PaymentDetails | Record<string, unknown>,
  ): Promise<Payment | undefined> => {
    setLoading(true);
    setError(null);
    try {
      const payment = await processPaymentApi(paymentData as PaymentDetails);
      setPaymentResult({ success: true, payment });
      return payment;
    } catch (err: unknown) {
      setError(getErrorMessage(err));
      return undefined;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    paymentResult,
    handlePayment,
    processPayment: handlePayment,
  };
};

export default usePayment;
